<div class="empty-wrapper">
  <div class="empty-collection-icon"></div>
  <h4 class="title">{{ this.title }}</h4>
  <div class="message">{{ this.message }}</div>
</div>
